import { createFileRoute, Outlet } from "@tanstack/react-router";
import PageNavigationTabs from "@/components/navigation/page-navigation-tabs";

export const Route = createFileRoute("/_super/super/control-panel/$companyId")({
  component: ControlPanelLayout,
});

function ControlPanelLayout() {
  const { companyId } = Route.useParams();

  const tabs = [
    {
      name: "Vista General",
      href: `/super/control-panel/${companyId}/overview`,
      icon: "LayoutDashboard",
      description: "Información general de la empresa",
    },
    {
      name: "Suscripción",
      href: `/super/control-panel/${companyId}/subscription`,
      icon: "CreditCard",
      description: "Gestión de plan y suscripción",
    },
    {
      name: "Usuarios",
      href: `/super/control-panel/${companyId}/users`,
      icon: "Users",
      description: "Gestión de usuarios de la empresa",
    },
    {
      name: "Uso",
      href: `/super/control-panel/${companyId}/usage`,
      icon: "BarChart3",
      description: "Métricas y uso de recursos",
    },
    {
      name: "Historial",
      href: `/super/control-panel/${companyId}/history`,
      icon: "History",
      description: "Historial de cambios y actividad",
    },
  ];

  return (
    <div className="space-y-6">
      <PageNavigationTabs
        tabs={tabs}
        variant="simple-underline"
        size="default"
        showIcons={true}
        alignment="left"
      />
      <Outlet />
    </div>
  );
}
